module.exports = __webpack_public_path__ + "img/flyer_asamblea2020_suspendida.5c091045.jpg";